import React from "react";
import "./BankDetails.css";
import { Container } from "react-bootstrap";

const BankDetails = () => {
  return (
    <div className="bd-wrapper">
      <Container>
        <div className="bd-container">
          
          <header className="bd-header">
            <h1 className="bd-title">Payment & Account Information</h1>
            <div className="bd-divider"></div>
            <p className="bd-subtitle">Secure and convenient transfer options for your reservations.</p>
          </header>

          <div className="bd-content">
            
            {/* Terms Card */}
            <section className="bd-card">
              <h2 className="bd-card-title">Accounts & Payment Terms</h2>
              <div className="bd-terms-content">
                <div className="bd-term-item">
                  <div className="bd-term-text">
                    <span className="bd-label">Initial Deposit</span>
                    <p className="bd-text">Any confirmation is subject to a non-refundable advance deposit of <strong className="bd-highlight">INR 2500 Per Person</strong> and has to be paid immediately, after we process the booking.</p>
                  </div>
                </div>
                <div className="bd-term-item">
                  <div className="bd-term-text">
                    <span className="bd-label">Balance Payment</span>
                    <p className="bd-text">Has to be made in advance and must be paid & settled at the time of reconfirmation (Min 07 days prior to the date of arrival).</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Domestic Details */}
            <section className="bd-card">
              <h2 className="bd-card-title">Domestic Transfers (Plenary Holidays)</h2>
              
              <div className="bd-list-group">
                <div className="bd-list-item">
                  <span className="bd-label">Demand Draft</span>
                  <span className="bd-value">In favor of <strong className="bd-highlight">"PLENARY HOLIDAYS"</strong> payable at Delhi.</span>
                </div>
                <div className="bd-list-item">
                  <span className="bd-label">At Par Cheque</span>
                  <span className="bd-value">Issue in the name of <strong className="bd-highlight">"PLENARY HOLIDAYS"</strong>.</span>
                </div>
              </div>

              <div className="bd-account-box">
                <h3 className="bd-box-title">Cash / Cheque Deposit Details</h3>
                <div className="bd-account-grid">
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">A/c Name</span>
                    <span className="bd-grid-value bd-highlight">PLENARY HOLIDAYS</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">A/C Number</span>
                    <span className="bd-grid-value bd-account-number">135305001106</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">Branch</span>
                    <span className="bd-grid-value">ICICI BANK-PP Tower Branch</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">IFSC/NEFT/RTGS</span>
                    <span className="bd-grid-value bd-account-number">ICIC0001353</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">Location</span>
                    <span className="bd-grid-value">Delhi</span>
                  </div>
                </div>
              </div>
            </section>

            {/* International Details */}
            <section className="bd-card">
              <h2 className="bd-card-title">Inter-Country Transfers</h2>
              <div className="bd-account-grid">
                 <div className="bd-grid-row">
                    <span className="bd-grid-label">Bank Branch Address</span>
                    <span className="bd-grid-value">PP Tower Branch, Netaji Subhash Place, Pitampura, Delhi-110034</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">Intermediary Bank</span>
                    <span className="bd-grid-value">J P Morgan Chase Bank, New York</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">Swift Code (USD)</span>
                    <span className="bd-grid-value bd-account-number">CHASUS33XXX</span>
                  </div>
                  <div className="bd-grid-row">
                    <span className="bd-grid-label">Swift Code (INR)</span>
                    <span className="bd-grid-value bd-account-number">ICICINBBCTS NEFT</span>
                  </div>
              </div>
            </section>

          </div>
        </div>
      </Container>
    </div>
  );
};

export default BankDetails;